import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/billing-vouchers.js';
import { insightsScopeKey } from '../insights/filter-params.js';
import q from '../query.js';
export const billingVouchersEntity = `billing-vouchers`;
export const billingVouchersKey = (caseId) => `billing-vouchers-${caseId}`;
export const useBillingVouchers = (caseId) => q.query(billingVouchersKey(caseId), () => api.getByCaseId(caseId), keys.read.collection(billingVouchersEntity));
const revenueByMonthKey = (from, to) => `revenue-by-month-${from}-${to}`;
export const useRevenueByMonth = (from, to, { caseGroupIds = [], creditorIds = [], } = {}) => q.query(`${revenueByMonthKey(from, to)}-${insightsScopeKey({ caseGroupIds, creditorIds })}`, () => api.getRevenueByMonth(from, to, {
    caseGroupIds,
    creditorIds,
}), []);
const revenueByCollectionCommissionSourceKey = (from, to) => `revenue-by-collection-commission-source-${from}-${to}`;
export const useRevenueByCollectionCommissionSource = (from, to, { caseGroupIds = [], creditorIds = [], } = {}) => q.query(`${revenueByCollectionCommissionSourceKey(from, to)}-${insightsScopeKey({ caseGroupIds, creditorIds })}`, () => api.getRevenueByCollectionCommissionSource(from, to, {
    caseGroupIds,
    creditorIds,
}), []);
const revenueByFeeVoucherTypeKey = (from, to) => `revenue-by-fee-voucher-type-${from}-${to}`;
export const useRevenueByFeeVoucherType = (from, to, { caseGroupIds = [], creditorIds = [], } = {}) => q.query(`${revenueByFeeVoucherTypeKey(from, to)}-${insightsScopeKey({ caseGroupIds, creditorIds })}`, () => api.getRevenueByFeeVoucherType(from, to, {
    caseGroupIds,
    creditorIds,
}), []);
const revenueBillingSpeedKey = (from, to) => `revenue-billing-speed-${from}-${to}`;
export const useRevenueBillingSpeed = (from, to, { caseGroupIds = [], creditorIds = [], } = {}) => q.query(`${revenueBillingSpeedKey(from, to)}-${insightsScopeKey({ caseGroupIds, creditorIds })}`, () => api.getRevenueBillingSpeed(from, to, {
    caseGroupIds,
    creditorIds,
}), []);
const revenueWorkInProgressKey = `revenue-work-in-progress`;
export const useRevenueWorkInProgress = ({ caseGroupIds = [], creditorIds = [], } = {}) => q.query(`${revenueWorkInProgressKey}-${insightsScopeKey({ caseGroupIds, creditorIds })}`, () => api.getRevenueWorkInProgress({
    caseGroupIds,
    creditorIds,
}), []);
const revenueByCreditorAndCaseGroupKey = (from, to) => `revenue-by-creditor-and-case-group-${from}-${to}`;
export const useRevenueByCreditorAndCaseGroup = (from, to, { caseGroupIds = [], creditorIds = [], } = {}) => q.query(`${revenueByCreditorAndCaseGroupKey(from, to)}-${insightsScopeKey({ caseGroupIds, creditorIds })}`, () => api.getRevenueByCreditorAndCaseGroup(from, to, {
    caseGroupIds,
    creditorIds,
}), []);
//# sourceMappingURL=index.js.map